import { AxiosResponse } from "axios";
import { api } from ".";
import { INormalisedRelations, RelationshipsResponse } from "../types";

export interface IV2MediaItem {
  id: number;
  name: string;
  description: string;
  thumbnail: string;
  media_type: string;
  remote_details: {
    url: string;
    size: string;
  };
  created_at: string;
  last_updated_at: string;
  relationships?: RelationshipsResponse;
  relations?: INormalisedRelations;
}

export interface IV2MediaResponse {
  count: number;
  next: string | null;
  previous: string | null;
  results: IV2MediaItem[];
}

/**
 * Fetches media from the v2 API.
 */
export const getV2Media = async (params?: {
  page?: number;
  page_size?: number;
  search?: string;
}): Promise<AxiosResponse<IV2MediaResponse>> => {
  return api.get("v2/media/", {
    params: {
      ...(params?.page ? { page: params.page } : {}),
      ...(params?.page_size ? { page_size: params.page_size } : {}),
      ...(params?.search ? { search: params.search } : {})
    }
  });
};

/**
 * Fetches a single media item from the v2 API.
 */
export const getV2MediaItem = async (id: string | number): Promise<AxiosResponse<IV2MediaItem>> => {
  return api.get(`v2/media/${id}/`);
};

/**
 * Permanently deletes a media item via the v2 API.
 * Endpoint: DELETE /api/v2/media/{id}/
 */
export const deleteV2MediaItem = async (id: string | number): Promise<void> => {
  await api.delete(`v2/media/${id}/`);
};

/**
 * Updates a media item's name/description via the v2 API.
 * Endpoint: PATCH /api/v2/media/{id}/
 */
export const updateV2MediaItem = async (
  id: string | number,
  data: { name?: string; description?: string; restrictions?: number[] }
): Promise<AxiosResponse<IV2MediaItem>> => {
  return api.patch(`v2/media/${id}/`, data);
};
